const API = process.env.REACT_APP_BACKEND_URL;

export async function initPushNotifications(token) {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    console.log("Push notifications not supported");
    return false;
  }

  try {
    // Register service worker
    const registration = await navigator.serviceWorker.register("/sw-push.js");
    console.log("Push SW registered");

    // Get VAPID key from backend
    const res = await fetch(`${API}/api/push/vapid-key`);
    const { public_key } = await res.json();
    if (!public_key) return false;

    // Request permission
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.log("Notification permission denied");
      return false;
    }

    // Subscribe
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(public_key)
    });

    // Send subscription to backend
    await fetch(`${API}/api/push/subscribe`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({ subscription: subscription.toJSON() })
    });

    console.log("Push notification subscription saved");
    return true;
  } catch (err) {
    console.error("Push init failed:", err);
    return false;
  }
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
